var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titleBox"},[_c('span',{staticClass:"title-color-box"}),_c('span',{staticClass:"tips",style:(_vm.styleObj ? _vm.styleObj : '')},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }